
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/amanaki-boutique-saigon/stories",
      function () {
        return require("private-next-pages/[locale]/amanaki-boutique-saigon/stories/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/amanaki-boutique-saigon/stories"])
      });
    }
  